import React from 'react';

const RootContext = React.createContext(window.document);

export const RootProvider = RootContext.Provider;
export default RootContext;
